import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Box,
} from "@mui/material";

import React from "react";
import { useSelector } from "react-redux";
import {
  confirmMessage,
  confirmTitle,
  endMessage,
} from "../features/trnAppSlice";
import Button from "@mui/material/Button";
import { isKiosk } from "../features/trnAppSlice";
import ConfirmationEndMessage from "./ConfirmationEndMessage";

import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import Tooltip from "@mui/material/Tooltip";
import { config } from "../config";

const Confirmation = () => {
  const confirmationText = useSelector(confirmMessage);
  const confirmationHeader = useSelector(confirmTitle);

  const surveyURL = config.SURVEYLINK;
  const kioskMode = useSelector(isKiosk);
  const isEndMessage = useSelector(endMessage);

  return (
    <>
      <Card>
        <CardHeader title={confirmationHeader} />
        <CardContent>
          <Typography>{confirmationText}</Typography>
          {isEndMessage && <ConfirmationEndMessage />}
        </CardContent>
      </Card>
      <br />
      <Box
        sx={{
          display: { xs: "none", sm: "none", md: "none", lg: "block" },
        }}
      >
        <Grid
          container 
          //xs={12}
          justifyContent={"center"}
          sx={{ marginBottom: "1%" }}
        >
          {surveyURL !== "" ? (
            <Tooltip title="Satisfaction Survey">
              <Button
                variant="contained"
                color="success"
                sx={{
                  borderRadius: "10px",
                  verticalAlign: "top",
                  borderColor: "white",
                }}
                startIcon={
                  <PollOutlinedIcon aria-label="Key" fontSize="large" />
                }
                onClick={() => {
                  if (kioskMode) {
                    window.parent.postMessage(
                      {
                        sender: "iframe",
                        type: "Navigate",
                        location: surveyURL + "kiosk",
                      },
                      "*"
                    );
                  } else {
                    window.open(
                      surveyURL + "website",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                Please take a moment to complete a survey on your interaction
              </Button>
            </Tooltip>
          ) : null}
        </Grid>
      </Box>
    </>
  );
};

export default Confirmation;
